// Vue-komponent <eui-modifierad-svg>
// Tar en rå svg-markup och modifierar den på önskat sätt. Modifieringen sker genom att ange class och/eller style på denn komponent. Dessa ersätter/mergeas då med den råa svg-markupens root-element.

import AllaSvgikoner from 'Svgikoner';

// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
//let uniktIdCounter = 0;


//###################################################################################################

export default {

	name: 'eui-modifierad-svg',

	functional: true,		// Is "functional", which means that they’re stateless (no reactive data) and instanceless (no this context).

	template: '#dynamic',	// Ersätts...

	render(createElement, context) {

		console.assert(!context.children,
			'Denna komponent får inte ha några undernoder.'
		);

		const template = context.props.vpSvgMarkup || AllaSvgikoner[context.props.vpIkon];

		console.assert(template,
			`Det finns ingen ikon med namnet '${context.props.vpIkon}'.`
		);

		const component = { template };

		// Lägg till en class:
		//context.data.staticClass += ' -anim-fade-in-fast';

		return createElement(component,

			// Fixa så att "attributes not defined as props are automatically added to the root element of the component, replacing or intelligently merging with any existing attributes of the same name":
			// Passing down any attributes or event listeners used on component:
			// https://vuejs.org/v2/guide/render-function.html#Passing-Attributes-and-Events-to-Child-Elements-Components
			context.data	
		);
	},

	// Props utöver de från mixin ovan:
	props: {
		vpIkon: {
			type: String,
			default: undefined
		},
		vpSvgMarkup: {
			type: String,
			default: undefined
		},
	},

	//methods: {
	//},
}
